import { ComponentType } from "react";

import { ILLFTemplateRenderer } from "@multiweb/customization";
import { FrameSharedProps } from "../../../../../types";
import { DataRowTemplate } from "../../../../DataRowTemplate";

/** Výchozí renderer pro šablonu řádku */
export class LLFDefaultTemplateRenderer implements ILLFTemplateRenderer {
    public readonly key: string;

    constructor(key: string) {
        this.key = key;
    }
    public get component(): ComponentType<FrameSharedProps> {
        return DataRowTemplate;
    }
}
